var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomInvestment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.82 13.786h3.663c.725 0 1.313.587 1.313 1.313v6.03h-6.29V15.1c0-.726.587-1.313 1.313-1.313z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.217 9.587h3.664c.725 0 1.313.587 1.313 1.313v10.23h-6.29V10.9c0-.726.587-1.313 1.313-1.313z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.598 5.388h3.663c.726 0 1.314.587 1.314 1.313V21.13h-6.29V6.7c0-.725.587-1.313 1.313-1.313z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.452 23.48c0-.432.345-.795.795-.795H26.85c.432 0 .795.345.795.795a.793.793 0 0 1-.795.795H3.247a.804.804 0 0 1-.795-.795z",
    fill: "#1E2969"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomInvestment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-investment.2d0b57ebc36d982759e18886196f7f95.svg";